export default '/build/d3890075.svg'